const Stepper = () => {
    return (
        <div className="stepper">
            <div className="stepper__item">
                <div className="stepper__content">
                    <h3>Bantaran Kali Code</h3>
                </div>
            </div>
            <div className="stepper__item">
                <div className="stepper__content">
                    <h3>Genangan Air di Jalan Jendral Sudirman</h3>
                </div>
            </div>
            <div className="stepper__item">
                <div className="stepper__content">
                    <h3>Flyover Dr. Sutomo {'(Lempuyangan)'}</h3>
                </div>
            </div>
            <div className="stepper__item">
                <div className="stepper__content">
                    <h3>Jalan Kusbini</h3>
                </div>
            </div>
        </div>
    )
}

export default Stepper